class CFaq extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.buttons = this.querySelectorAll('.accordeon-button')
    this.buttons.forEach((button) => {
      if (button.dataset.initialized) return
      button.dataset.initialized = 'true'
      button.addEventListener('click', () => this.toggle(button))
      button.addEventListener('keydown', (e) => this.handleKeyboard(e, button))
    })
  }

  toggle(button) {
    const isExpanded = button.getAttribute('aria-expanded') === 'true'
    const panel = document.getElementById(button.getAttribute('aria-controls'))
    button.setAttribute('aria-expanded', !isExpanded)
    panel.hidden = isExpanded

    button.closest('.accordeon').classList.toggle('is-open', !isExpanded)
  }

  handleKeyboard(event, button) {
    const buttons = Array.from(this.buttons)
    const currentIndex = buttons.indexOf(button)

    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault()
        const nextButton = buttons[currentIndex + 1] || buttons[0]
        nextButton.focus()
        break
      case 'ArrowUp':
        event.preventDefault()
        const prevButton =
          buttons[currentIndex - 1] || buttons[buttons.length - 1]
        prevButton.focus()
        break
      case 'Home':
        event.preventDefault()
        buttons[0].focus()
        break
      case 'End':
        event.preventDefault()
        buttons[buttons.length - 1].focus()
        break
    }
  }
}

customElements.define('c-faq', CFaq)
